import classNames from 'classnames/bind';
import { useRef, useState } from 'react';
import styles from './TipButton.module.css';

import {
  FILE_INFO_GUIDE,
  FILE_SHARE_GUIDE,
  START_PAGE_TOOLTIP,
  SHARE_INFO_GUIDE,
  TOTAL_CORRECT_RATE_DESC,
} from '../../constants';
import Popover from '../Popover';
import { StringByKey } from '../../types/common';
import { useAppSelector } from '../../hooks/useRedux';
import { selectMenu } from '../../features/infoSlice';

interface ITipButton {
  name: string;
}

export default function TipButton({ name }: ITipButton) {
  const cx = classNames.bind(styles);
  const menu = useAppSelector(selectMenu);
  const buttonRef = useRef<HTMLSpanElement>(null);
  const [isShownPopover, setIsShownPopover] = useState(false);

  const togglePopover = (e: React.MouseEvent | MouseEvent | Event) => {
    e.stopPropagation();
    setIsShownPopover(!isShownPopover);
  };

  const contentList: StringByKey = {
    fileShare: FILE_SHARE_GUIDE,
    startPage: START_PAGE_TOOLTIP,
    shareInfo: SHARE_INFO_GUIDE,
    fileInfo: FILE_INFO_GUIDE[menu],
    totalCorrectRate: TOTAL_CORRECT_RATE_DESC,
  };

  const content = contentList[name];

  return (
    <>
      <span
        role="button"
        className={cx('btn', 'tip_help_over', name)}
        onClick={togglePopover}
        ref={buttonRef}
      ></span>
      {isShownPopover && (
        <Popover
          name={name}
          content={content}
          onClose={togglePopover}
          buttonRef={buttonRef}
        />
      )}
    </>
  );
}
